import axios from 'axios'
import { ALTERAR_TOMADOR } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function alterarTomador (comandoTomador) {
    return dispatch => axios.post(`${URL}/tomador/alterar`, comandoTomador, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: ALTERAR_TOMADOR,
        payload: response.data
      })
    )
  }
